import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/lib/theme";

export const ThemeToggle = ({ className = "" }) => {
    const { theme, toggle } = useTheme();
    return (
        <button
            type="button"
            data-testid="theme-toggle-button"
            onClick={toggle}
            aria-label={theme === "dark" ? "Aktifkan mode terang" : "Aktifkan mode gelap"}
            className={`flex items-center justify-center rounded-full border border-white/15 bg-white/5 p-2.5 text-zinc-300 transition-colors duration-200 hover:border-amber-400/50 hover:text-amber-300 ${className}`}
        >
            {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </button>
    );
};
